import React, {useMemo} from 'react';
import {useSearchParams} from "react-router-dom";

import {usePrevious} from "react-use";
import {useOpportunity} from "../../../providers/OpportunityProvider";
import ManageOppMeetings from "../../../components/meetings/ManageOppMeetings";
import TalentCoverLetterEditTab from "./TalentCoverLetterEditTab";
import TalentRelevantExpEditTab from "./TalentRelevantExpEditTab";
import {Tabs} from "antd";
import MessagesTab from "../../proposals/MessagesTab";
import Scrollbars from "react-custom-scrollbars";
import TeamCandidateScopeProvider from "../../client-lead-tools/team-scope/TeamCandidateScopeProvider";
import Team from "../../../models/Team";
import Opportunity from "../../../models/Opportunity";


const MatchedTeamPanel = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const previousLocationSearch = usePrevious(searchParams.get('tabView'));

    const {
        isDisabled,
        onAccept,
        onReject,
        onUpdate,
        opportunity: agencyOpportunity
    } = useOpportunity();

    const onUpdateOpp = (params) => {
        return onUpdate(params, props.opportunity)
    }

    const tabs = [
        {
            key: "cover-letter",
            label: "Cover Letter",
            children: (
                <TalentCoverLetterEditTab opportunity={props.opportunity}/>
            )
        },
        {
            key: "relevant-experience",
            label: "Relevant Experience",
            children: (
                <div className={TB.mapClass({
                    disabled: isDisabled
                })}>
                    <TalentRelevantExpEditTab opportunity={props.opportunity}/>
                </div>
            )
        },
        {
            key: "interviews",
            label: "Interviews",
            children: (
                <div className={TB.mapClass({
                    disabled: isDisabled
                })}>
                    <Scrollbars style={{width: `100%`, height: 600}}>
                    <ManageOppMeetings
                        opportunity={props.opportunity}/>
                    </Scrollbars>
                </div>
            )
        },
    ]

    const selectedTab = useMemo(() => {
        if (props.selectedTab) return props.selectedTab;
        let tab;
        if (searchParams.has('tabView')) {
            tab = TB.find(tabs, tab => TB.slugify(tab.key) === searchParams.get('tabView'));
        }
        if (!tab) {
            tab = previousLocationSearch || TB.first(tabs)
        }
        return tab.key;
    }, [location.search, props.selectedTab]);

    const matchedTeam = useMemo(() => {
        let teamOpp = Opportunity.make({
            ...props.opportunity,
            team: agencyOpportunity.team
        });
        let candidate = {...teamOpp, ...teamOpp.team};
        delete candidate.team;
        delete candidate.project;
        candidate.disciplines = [...(agencyOpportunity.project.disciplines || [])]
        return Team.make(candidate);
    }, [agencyOpportunity, props.opportunity]);

    const setSelectedTab = (tab) => {
        if (props.onTabChange) {
            return props.onTabChange(tab)
        }
        let params = new URLSearchParams(searchParams);
        params.set('tabView', tab);
        return setSearchParams(params, { replace: true })
    };

    return (
        <TeamCandidateScopeProvider
            opportunityId={agencyOpportunity.id}
            team={matchedTeam} project={agencyOpportunity.project}
            isDisabled={isDisabled}
        >
            <div className="proposal-container opportunity-proposal agency-opp-proposal">


                <div className="flex flex-row items-stretch lg:divide-x lg:divide-gray-200">
                    <div className="flex-grow">
                        <Tabs items={tabs} activeKey={selectedTab} onChange={setSelectedTab}/>
                    </div>
                    <div className="agency-messsage-container flex flex-col items-stretch justify-start gap-2 lg:pl-5 py-4">
                        <div className="my-2">
                            <p className="font-semibold">Messages</p>
                            <p className="text-sm">
                                Chat with the client to get more information
                            </p>
                        </div>
                        <div className="proposal-messages candidate-messages">
                            <MessagesTab
                                hasPermission={true}
                                opportunity={props.opportunity}
                                candidate={props.opportunity.job_candidate}
                                onFetchSuccess={() => {

                                    console.log('props.opp', props.opportunity)
                                    // setOpportunity(
                                    //     Opportunity.make({
                                    //         ...props.opportunity,
                                    //         unread_messages_count: 0
                                    //     })
                                    // )
                                }}
                            />
                        </div>
                    </div>
                </div>

            </div>
        </TeamCandidateScopeProvider>
    )
}

export default MatchedTeamPanel;